import styled from 'styled-components'

export const PendenciesHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
export const PendenciesContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  gap: 16px;
  text-align: center;
  svg {
    max-width: 80%;
  }
`
